import { render } from "./DeliveryNote.vue?vue&type=template&id=bd74d0d8&scoped=true"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"

import "./DeliveryNote.vue?vue&type=style&index=0&id=bd74d0d8&scoped=true&lang=css"
import "./DeliveryNote.vue?vue&type=style&index=1&id=bd74d0d8&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd74d0d8"]])

export default __exports__